<template>
	<div class="jiedaiOrder">
		<div class="radioBox">
			<el-radio-group v-model="radio" @change="changeRadio">
				<el-radio :label="0">全部</el-radio>
				<el-radio :label="1">未完成</el-radio>
				<el-radio :label="2">已完成</el-radio>
			</el-radio-group>
		</div>
		<el-table :data="tableData" style="width: 100%" height="100%">
			<el-table-column label="单号" prop="serviceId" width="90">
			</el-table-column>
			<el-table-column label="顾客" prop="memberName" width="90">
			</el-table-column>
			<el-table-column label="宠物昵称" prop="petName" width="80">
			</el-table-column>
			<el-table-column label="类别" width="50">
				<template slot-scope="props">
					<div v-if="props.row.serviceTypeId===1">疫苗</div>
					<div v-if="props.row.serviceTypeId===2">驱虫</div>
				</template>
			</el-table-column>
			<el-table-column label="套餐名称" min-width="150" prop="servicePackageName">
			</el-table-column>
			<el-table-column label="计划名称" width="110" prop="planName">
			</el-table-column>
			<el-table-column label="实施计划" width="70" prop="planName">
				<template slot-scope="props">
					<div>
						<span>{{props.row.planIndex}}</span>/<span>{{props.row.planCount}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="计划时间" width="85">
				<template slot-scope="props">
					<div>{{$public.FTime(props.row.planDate,'YYYY-MM-DD')}}</div>
				</template>
			</el-table-column>
			<el-table-column label="支付状态" width="70">
				<template slot-scope="props">
					<div style="color:#18A44C" v-if="props.row.isPay==true">已支付</div>
					<div style="color:#FD4E4E" v-else>未支付</div>
				</template>
			</el-table-column>
			<el-table-column label="创建门店" width="70">
				<template slot-scope="props">
					<span v-if="props.row.shopId">{{$public.getShopNameById(props.row.shopId)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="备注" prop="remark" width="60">
			</el-table-column>
			<el-table-column label="操作" width="50">
				<template slot-scope="props">
					<el-button type="text" size="mini" @click="seePet(props.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBox">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
		<ymqcSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></ymqcSee>
	</div>
</template>
<script>
	import page from "../../../../../components/page.vue"
	import dialogSettlement from "../../../../../components/dialog_settlement.vue"
	import ymqcSee from "../../drawer/ymqcSee.vue"
	export default {
		components:{page,dialogSettlement,ymqcSee},
		data(){
			return{
				radio:0,
				tableData:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				// 结算
				dialogSettlementState: false,
				curOrder: {},
				// see
				drawerJiyangPetSee_state:false,
				curItem:{},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			// changeRadio
			changeRadio(){
				this.page.page=1;
				this.getTableData();
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			// 结算
			pay(row) {
				this.curOrder = row
				this.dialogSettlementState = true;
			},
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.getTableData();
			},
			// 离院
			leave(row){
				this.$confirm('确定要离院?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/InHospital/Leave', {inHospitalId:row.id}).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '离院成功',
								type: 'success'
							});
							this.getTableData()
						}
					})
				})
			},
			changePage(num){
				this.page.page=num;
				this.getTableData();
			},
			// 获取列表数据
			getTableData() {
				let curDay = this.$public.FTime(new Date().getTime(),'YYYY-MM-DD')
				let params = {
					"keyword": '',
					petId:'',
					"serviceTypeId": 0,  // 1疫苗；2驱虫; Default:0 
					"isPay": -1,          // -1 全部；0未支付；1已支付
					"petType": "",       //  猫类；犬类
					"status": this.radio,         // 1未完成；2已完成
					"isOut": 0,        // -1 0 1 2
					hasGoods:true,
					"desc": true,
					"shopId":this.curShopId,
					planBeginDate: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
					planEndDate: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading=this.$loading();
				this.$http.post('/api/MedicalPackage/Plan/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.jiedaiOrder{
	width:100%;height: 100%;padding-bottom:50px;box-sizing: border-box;padding-top:40px;position: relative;
	.radioBox{
		padding:12px 30px 12px;position: absolute;z-index: 1;top:0;width:100%;box-sizing: border-box;
	}
	.pageBox{
		// padding:20px;
	}
}
</style>
